exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse-enter-active,.collapse-leave-active{transition:height .2s ease-in-out;overflow:hidden}.collapse-enter,.collapse-leave-to{height:0}", ""]);

// exports
